<template>
  <div
    v-if="!!activeJob"
    class="i-career-responsibilities"
  >
    <iKeywordDetailsSummary
      v-if="showResponsibilities"
      :data="activeJob.responsibilities.items"
      :summary="activeJob.responsibilities.summary"
      show-summary-first
      :show-keys="false"
    />
    <div
      v-if="
        GlobalFunctions.isExtendedRecommendedJobType(activeJob) && !showResponsibilities && activeJob.matchingSkills
      "
      class="matching"
    >
      {{ activeJob.matchingSkills }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useReportStore } from "@/stores/report"

import { GlobalFunctions } from "@/helpers/globalFunctions"

import iKeywordDetailsSummary from "@/components/report/KeywordDetailsSummary.vue"

// STORES AND COMPOSABLES
const reportStore = useReportStore()

// COMPUTED
const activeJob = computed(() => reportStore.getActiveJob)
const showResponsibilities = computed(
  () => !!activeJob.value?.responsibilities.summary && hasResponsibilitiesItems(activeJob.value?.responsibilities.items)
)

// FUNCTIONS
const hasResponsibilitiesItems = (items: { [title: string]: string }) => {
  return !!items && typeof items === "object" && Object.keys(items).length > 0
}
</script>

<style lang="scss" scoped>
.i-career-responsibilities {
  margin: 25px 0 40px;

  .matching {
    @include text-md;

    font-weight: 500;
    color: $comet600;
    padding: 20px;
    background-color: $azure-radiance100;

    @include border-radius-md;
  }
}
</style>
